import type { StepDay } from "@/lib/types";

// 최근 7일 걸음 막대 — 오늘(마지막 칸)만 primary 색으로 강조한다.
export default function StepWeekBars({ days }: { days: StepDay[] }) {
  const max = Math.max(1, ...days.map((d) => Number(d.steps) || 0));

  return (
    <div className="flex h-20 items-end justify-between gap-2">
      {days.map((d) => {
        const v = Number(d.steps) || 0;
        const h = Math.max(6, Math.round((v / max) * 100));
        const today = Number(d.today) === 1;
        return (
          <div key={d.d} className="flex flex-1 flex-col items-center gap-1.5">
            <div className="flex h-10 w-full items-end" title={`${d.d} · ${v.toLocaleString("ko-KR")}보`}>
              <div
                className={`w-full rounded-sm ${today ? "bg-primary-500" : "bg-background-300"}`}
                style={{ height: `${h}%` }}
              ></div>
            </div>
            <span
              className={`text-[11px] ${
                today ? "font-semibold text-primary-700" : "text-foreground-400"
              }`}
            >
              {d.dow}
            </span>
          </div>
        );
      })}
    </div>
  );
}